import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToolbarModule } from '@components/toolbar';
import { ButtonModule } from '@components/button';
import { DirectivesModule } from '@directives/directives.module';
import { PopUpModule } from '@components/pop-up';
import { ProductCarouselModule } from '@shared/product-carousel/product-carousel.module';
import { SwiperModule } from 'swiper/angular';
import { LoadingModule } from '@components/loading';
import { CsIconModule } from '@components/icon';
import { CureskinCashSheetModule } from '@shared/bottom-sheet-layouts/cureskin-cash-sheet/cureskin-cash.module';
import { ShopCarouselsModule } from '@shared/shop-carousels/shop-carousels.module';
import { LoaderShopModule } from '@shared/loader-shop/loader-shop.module';
import { DiscontinuedPopupModule } from '@shared/discontinued-popup/discontinued-popup.module';
import { CartDetailStripModule } from '@shared/cart-detail-strip/cart-detail-strip.module';
import { AovSaleModule } from '@shared/aov-sale/aov-sale.module';
import { ShopBannersModule } from '@shared/shop-order-banners/shop-order-banners.module';
import { UserProfileModule } from '../../../user-profile/user-profile.module';
import { BannerScrollbarModule } from '../user-home/banner-scrollbar/banner-scrollbar.module';
import { DietBannerModule } from '../user-home/diet-banner/diet-banner.module';
import { OrderDetailBannerModule } from '../user-home/order-details-banner/order-details-banner.module';
import { UserOrderBannerModule } from '../user-home/user-order-banner/user-order-banner.module';
import { UserShopComponent } from './user-shop.component';
import { AovBannerComponent } from '../../../cart/aov-banner/app-aov-banner.component';
import {CrossRegimenBannerV2Component} from '../user-home/cross-regimen-banner-v2/cross-regimen-banner-v2.component';
import { RecentlyViewedProductsComponent } from '@shared/recently-viewed-products/recently-viewed-products.component';
import { ProductCardComponent } from 'client/app/shop/components/product-card/product-card.component';
import { ProductComponent } from "client/app/shop/components/product/product.component";
import { ProductHorizontalComponent } from "client/app/shop/components/product-horizontal/product-horizontal.component";
import { LoaderShopRevampComponent } from "@components/loader-shop-revamp/loader-shop-revamp.component";
import { ProductCollectionComponent } from "@components/product-collection/product-collection.component";
import { ShopCollectionNavComponent } from "@components/shop-collection-nav/shop-collection-nav.component";
import { ProductCollectionBannerComponent } from "@components/product-collection-banner/product-collection-banner.component";
import { ProductCollectionJumboComponent } from "@components/product-collection-jumbo/product-collection-jumbo.component";
import { ProductJumboComponent } from 'client/app/shop/components/product-jumbo/product-jumbo.component';
import { RecommendedProductsComponent } from '@shared/recommended-products/recommended-products.component';

@NgModule({
    imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    ToolbarModule,
    ButtonModule,
    PopUpModule,
    UserProfileModule,
    ProductCarouselModule,
    BannerScrollbarModule,
    DietBannerModule,
    SwiperModule,
    OrderDetailBannerModule,
    UserOrderBannerModule,
    LoadingModule,
    CureskinCashSheetModule,
    CsIconModule,
    ProductCardComponent,
    ShopCarouselsModule,
    LoaderShopModule,
    DiscontinuedPopupModule,
    CartDetailStripModule,
    AovSaleModule,
    ShopBannersModule,
    AovBannerComponent,
    CrossRegimenBannerV2Component,
    RecentlyViewedProductsComponent,
    ProductComponent,
    ProductHorizontalComponent,
    LoaderShopRevampComponent,
    ProductCollectionComponent,
    ShopCollectionNavComponent,
    ProductCollectionBannerComponent,
    ProductCollectionJumboComponent,
    ProductJumboComponent,
    RecommendedProductsComponent,
],
  declarations: [UserShopComponent],
  exports: [UserShopComponent],
})
export class UserShopModule { }
